import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';
import ProfileDocumentsInvestments from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsInvestments';
import ProfileDocumentsPrivacySecurity from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsPrivacySecurity';
import ProfileDocumentsTax from 'pages/profile/components/ProfileTabContent/ProfileDocuments/ProfileDocumentsTax';
import React from 'react';
import useUserDetails from '../../../../../hooks/requests/user/hooks/useUserDetails';
import ProfileDocumentsLeases from './ProfileDocumentsLeases';

const ProfileDocuments = () => {
  const { isTenant } = useUserDetails();
  return (
    <>
      {!isTenant && (
        <ProfileSection
          title={'Taxes'}
          withBottomLine
        >
          <ProfileDocumentsTax />
        </ProfileSection>
      )}
      <ProfileSection
        title={'Privacy & Security'}
        withBottomLine
      >
        <ProfileDocumentsPrivacySecurity />
      </ProfileSection>
      {isTenant ? (
        <ProfileSection title={'Leases'}>
          <ProfileDocumentsLeases />
        </ProfileSection>
      ) : (
        <ProfileSection title={'Investments'}>
          <ProfileDocumentsInvestments />
        </ProfileSection>
      )}
    </>
  );
};

export default ProfileDocuments;
